import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ComboBox } from "./ComboBox";
import { multiSelectStrategy } from "./strategies";
export function ComboBoxMultiSelect(_ref) {
  var onAddItem = _ref.onAddItem,
      onRemoveItem = _ref.onRemoveItem,
      onSelectedItemChange = _ref.onSelectedItemChange,
      items = _ref.items,
      _ref$stateReducer = _ref.stateReducer,
      stateReducer = _ref$stateReducer === void 0 ? multiSelectStrategy : _ref$stateReducer,
      other = _objectWithoutProperties(_ref, ["onAddItem", "onRemoveItem", "onSelectedItemChange", "items", "stateReducer"]); // Provide more opinionated callbacks on when the user should add
  // or remove tokens


  function handleSelect(changes) {
    if (onSelectedItemChange) {
      onSelectedItemChange(changes);
    }

    var selectedItem = changes.selectedItem;
    return items.includes(selectedItem) ? onAddItem(selectedItem) : onRemoveItem(selectedItem);
  }

  return /*#__PURE__*/React.createElement(ComboBox, _extends({
    onSelectedItemChange: handleSelect,
    stateReducer: stateReducer,
    items: items,
    defaultHighlightedIndex: 0
  }, other));
}